(function () {

  'use strict';



  const STORAGE_KEY = 'nbl_size_calculator_grouped_v2';

  const LETTER_ORDER = { xxs: 1, xs: 2, s: 3, m: 4, l: 5, xl: 6, xxl: 7, '2xl': 7, '3xl': 8, xxxl: 8 };



  function normalize(value) {

    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '').trim();

  }



function toArray(value) {

  if (Array.isArray(value)) {

    return value

      .map(v => String(v).trim())

      .filter(Boolean);

  }



  if (value === null || value === undefined || value === '') return [];



  return String(value)

    .replace(/\\\n/g, '\n')

    .split(/[\r\n,;|/]+/)

    .map(v => v.trim())

    .filter(Boolean);

}



function numericValues(value) {

  return toArray(value)

    .map(v => parseInt(String(v).replace(/[^\d]/g, ''), 10))

    .filter(n => !Number.isNaN(n));

}



  function includesValue(metaValue, userValue) {

    const needle = normalize(userValue);

    return !!needle && toArray(metaValue).some(item => normalize(item) === needle);

  }



  function sizeRank(value) {

    const clean = normalize(value);

    if (LETTER_ORDER[clean]) return LETTER_ORDER[clean];

    const num = parseInt(clean.replace(/[^\d]/g, ''), 10);

    return Number.isNaN(num) ? null : num;

  }



  function getRanks(value) {

    return toArray(value).map(sizeRank).filter(n => n !== null);

  }



  function getMaxNumber(value) {

    const nums = numericValues(value);

    return nums.length ? Math.max.apply(null, nums) : null;

  }



  function text(root, key, fallback) {

    if (!root || !root.dataset) return fallback;

    const dataKey = 'txt' + key.charAt(0).toUpperCase() + key.slice(1);

    return root.dataset[dataKey] || fallback;

  }



  function escapeHtml(value) {

    return String(value || '')

      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/>/g, '&gt;')

      .replace(/"/g, '"')

      .replace(/'/g, '&#039;');

  }



  function isOneSizeVariant(variant) {

    if (typeof variant.oneSize === 'boolean') return variant.oneSize;

    const title = variant.title || '';

    if (!title || title === 'Default Title') return true;



    const parts = title.split('/').map(part => part.trim()).filter(Boolean);

    const last = parts[parts.length - 1] || title;

    const lastRank = sizeRank(last);



    if (parts.length >= 2) return false;

    return lastRank === null;

  }



  function getVariantSize(root, variant) {

    const sizePrefix = text(root, 'sizePrefix', 'Talla');

    const recommendedSize = text(root, 'recommendedSize', 'tu talla recomendada');

    const title = variant.title || '';



    if (isOneSizeVariant(variant)) return recommendedSize;



    if (title && title !== 'Default Title') {

      const parts = title.split('/').map(part => part.trim()).filter(Boolean);

      const last = parts[parts.length - 1] || title;

      return /^talla\s+/i.test(last) || /^size\s+/i.test(last) ? last : `${sizePrefix} ${last}`;

    }



    const tallas = toArray(variant.tallas);

    return tallas[0] ? `${sizePrefix} ${tallas[0]}` : recommendedSize;

  }



  function getRecommendedSizeValue(variant, userSize) {

    const ranks = getRanks(variant.tallas);

    const userRank = sizeRank(userSize);

    if (!ranks.length || userRank === null) return '';



    const sorted = Array.from(new Set(ranks)).sort((a, b) => a - b);

    if (sorted.includes(userRank)) return String(userSize);

    if (userRank < sorted[0]) return String(sorted[0]);

    if (userRank > sorted[sorted.length - 1]) return String(sorted[sorted.length - 1]);



    let closest = sorted[0];

    sorted.forEach(rank => {

      if (Math.abs(rank - userRank) < Math.abs(closest - userRank)) closest = rank;

    });

    return String(closest);

  }



  function getRecommendedBraValue(variant, userBra) {

    const braMax = getMaxNumber(variant.sujetadorMax);

    if (braMax === null || !userBra) return '';

    const user = parseInt(userBra, 10);

    if (Number.isNaN(user)) return '';

    return String(user <= braMax ? user : braMax);

  }



  function loadProfile() {

    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {}; } catch(e) { return {}; }

  }



  function saveProfile(data) {

    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch(e) {}

  }



  function fillFormFromProfile(form, profile, group) {

    if (!form || !profile || !profile[group]) return;

    Object.keys(profile[group]).forEach(key => {

      if (form.elements[key]) form.elements[key].value = profile[group][key];

    });

  }



  function collectData(form) {

    const fd = new FormData(form);

    return { talla: String(fd.get('talla') || ''), sujetador: String(fd.get('sujetador') || ''), tallaPantalon: String(fd.get('tallaPantalon') || '') };

  }



  function scoreSetDimension(values, selected) {
    const ranks = getRanks(values);
    const user = sizeRank(selected);
    if (user === null || !ranks.length) return {score: -100, compatible: false, diff: 99};
    if (includesValue(values, selected)) return {score: 100, compatible: true, diff: 0};
    const min = Math.min(...ranks), max = Math.max(...ranks);
    if (user < min) return {score: 85 - (min-user), compatible: true, diff: user-min};
    if (user > max) return {score: 80 - (user-max)*3, compatible: false, diff: user-max};
    return {score: 70, compatible: true, diff: 0};
  }

  function scoreSetVariant(variant, data) {
    const top = scoreSetDimension(variant.tallas, data.talla);
    const pants = scoreSetDimension(variant.tallasPantalon, data.tallaPantalon);
    const braMax = getMaxNumber(variant.sujetadorMax);
    const bra = parseInt(data.sujetador, 10);
    const pechoDiff = braMax === null || Number.isNaN(bra) ? 99 : Math.max(0, bra-braMax);
    const braScore = pechoDiff ? 80-pechoDiff*2 : 100 - Math.max(0, braMax-bra)*0.2;
    return {
      variant, score: top.score + pants.score + braScore,
      compatible: top.compatible && pants.compatible && pechoDiff === 0,
      tallaDiff: top.diff, pantalonDiff: pants.diff, pechoDiff,
      topCompatible: top.compatible && pechoDiff === 0, pantsCompatible: pants.compatible,
      isOneSize: isOneSizeVariant(variant),
      recommendedSize: getRecommendedSizeValue(variant, data.talla),
      recommendedPants: getRecommendedSizeValue({...variant, tallas: variant.tallasPantalon}, data.tallaPantalon),
      recommendedBra: getRecommendedBraValue(variant, data.sujetador)
    };
  }

  function scoreVariant(variant, data, group) {
    if (group === 'set') return scoreSetVariant(variant, data);

    const userRank = sizeRank(data.talla);

    const ranks = getRanks(variant.tallas);

    const maxRank = ranks.length ? Math.max.apply(null, ranks) : null;

    const minRank = ranks.length ? Math.min.apply(null, ranks) : null;

    const userBra = parseInt(data.sujetador, 10);

    const braMax = getMaxNumber(variant.sujetadorMax);

    let score = 0, compatible = true, tallaDiff = 0, pechoDiff = 0;



    if (includesValue(variant.tallas, data.talla)) score += 100;

    else if (ranks.length && userRank !== null) {

      if (userRank < minRank) {

        tallaDiff = userRank - minRank;

        score += 85 - Math.abs(tallaDiff);

      } else if (userRank > maxRank) {

        tallaDiff = userRank - maxRank;

        score += 80 - Math.abs(tallaDiff) * 3;

        compatible = false;

      } else {

        score += 70;

      }

    } else {

      compatible = false;

    }



    if (group !== 'bottom') {

      if (braMax !== null && !Number.isNaN(userBra)) {

        if (userBra <= braMax) score += 100 - Math.max(0, braMax - userBra) * 0.2;

        else {

          pechoDiff = userBra - braMax;

          score += 80 - pechoDiff * 2;

          compatible = false;

        }

      }

    }



    return {

      variant,

      score,

      compatible,

      tallaDiff,

      pechoDiff,

      isOneSize: isOneSizeVariant(variant),

      recommendedSize: getRecommendedSizeValue(variant, data.talla),

      recommendedBra: getRecommendedBraValue(variant, data.sujetador)

    };

  }



  function calculateRecommendation(variants, data, group) {

    const valid = variants.filter(v => v.ok && v.available);

    if (!valid.length) return null;

    const scored = valid.map(v => scoreVariant(v, data, group)).sort((a, b) => b.score - a.score);

    const compatible = scored.filter(item => item.compatible);

    return { best: compatible[0] || scored[0], hasCompatible: compatible.length > 0 };

  }



  function formatMeasureValue(root, value, unit) {

    const nums = numericValues(value);

    if (!nums.length) return '';

    if (nums.length === 1) return `${nums[0]}${unit}`;



    const min = Math.min.apply(null, nums);

    const max = Math.max.apply(null, nums);

    const stretchesTo = text(root, 'stretchesTo', 'estira hasta');



    return min === max ? `${min}${unit}` : `${min}${unit} (${stretchesTo} ${max}${unit})`;

  }



  function renderMeasureImage(root) {

    const image = root.dataset.measureImage || '';

    const alt = text(root, 'measureAlt', 'Guía de mediciones de la prenda');

    return image ? `<div class="nbl-size-calculator__measure-image"><img src="${escapeHtml(image)}" alt="${escapeHtml(alt)}" loading="lazy"></div>` : '';

  }



  function renderMeasures(root, variant, group) {

    const rows = [];

    const largo = formatMeasureValue(root, variant.largo, 'cm');

    const pecho = formatMeasureValue(root, variant.contornoPecho, 'cm');

    const cintura = formatMeasureValue(root, variant.contornoCintura, 'cm');

    const cadera = formatMeasureValue(root, variant.contornoCadera, 'cm');



    const garmentLength = text(root, 'garmentLength', 'Largo de la prenda');

    const bust = text(root, 'bust', 'Contorno pecho');

    const waist = text(root, 'waist', 'Contorno cintura');

    const hips = text(root, 'hips', 'Contorno cadera');

    const measurementsTitle = text(root, 'measurementsTitle', 'Medidas de la talla recomendada');



    if (group === 'set') {
      const topTitle = text(root, 'setTop', 'Top');
      const pantsTitle = text(root, 'setPants', 'Pantalón');
      const topRows = [], pantsRows = [];
      const add = (arr, label, value) => { if (value) arr.push(`<li><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></li>`); };
      add(topRows, garmentLength, formatMeasureValue(root, variant.conjuntoTopLargo, 'cm'));
      add(topRows, bust, formatMeasureValue(root, variant.conjuntoTopPecho, 'cm'));
      add(topRows, waist, formatMeasureValue(root, variant.conjuntoTopCintura, 'cm'));
      add(pantsRows, garmentLength, formatMeasureValue(root, variant.conjuntoPantalonLargo, 'cm'));
      add(pantsRows, waist, formatMeasureValue(root, variant.conjuntoPantalonCintura, 'cm'));
      add(pantsRows, hips, formatMeasureValue(root, variant.conjuntoPantalonCadera, 'cm'));
      if (!topRows.length && !pantsRows.length) return '';
      return `<div class="nbl-size-calculator__measures"><h4>${escapeHtml(measurementsTitle)}</h4>` +
        (topRows.length ? `<h5>${escapeHtml(topTitle)}</h5><ul>${topRows.join('')}</ul>` : '') +
        (pantsRows.length ? `<h5>${escapeHtml(pantsTitle)}</h5><ul>${pantsRows.join('')}</ul>` : '') + '</div>';
    }

    if (group === 'full') {

      if (largo) rows.push(`<li><span>${escapeHtml(garmentLength)}</span><strong>${escapeHtml(largo)}</strong></li>`);

      if (pecho) rows.push(`<li><span>${escapeHtml(bust)}</span><strong>${escapeHtml(pecho)}</strong></li>`);

      if (cintura) rows.push(`<li><span>${escapeHtml(waist)}</span><strong>${escapeHtml(cintura)}</strong></li>`);

      if (cadera) rows.push(`<li><span>${escapeHtml(hips)}</span><strong>${escapeHtml(cadera)}</strong></li>`);

    } else if (group === 'top') {

      if (largo) rows.push(`<li><span>${escapeHtml(garmentLength)}</span><strong>${escapeHtml(largo)}</strong></li>`);

      if (pecho) rows.push(`<li><span>${escapeHtml(bust)}</span><strong>${escapeHtml(pecho)}</strong></li>`);

    } else {

      if (largo) rows.push(`<li><span>${escapeHtml(garmentLength)}</span><strong>${escapeHtml(largo)}</strong></li>`);

      if (cintura) rows.push(`<li><span>${escapeHtml(waist)}</span><strong>${escapeHtml(cintura)}</strong></li>`);

      if (cadera) rows.push(`<li><span>${escapeHtml(hips)}</span><strong>${escapeHtml(cadera)}</strong></li>`);

    }



    return rows.length ? `<div class="nbl-size-calculator__measures"><h4>${escapeHtml(measurementsTitle)}</h4><ul>${rows.join('')}</ul></div>` : '';

  }



  function buildWarnings(root, result, group) {
    if (group === 'set') {
      const best = result.best;
      const en = root.dataset.lang === 'en';
      const warnings = [];
      if (!best.topCompatible) warnings.push(en ? 'The top may fit snugly.' : 'La parte de arriba podría quedarte justa.');
      if (!best.pantsCompatible) warnings.push(en ? 'The trousers may fit snugly.' : 'El pantalón podría quedarte justo.');
      return warnings;
    }

    const warnings = [];



    if (!result.hasCompatible) warnings.push(text(root, 'noPerfect', 'No hay una talla que encaje perfectamente con los datos indicados. Esta es la opción más cercana.'));

    if (result.best.tallaDiff > 1) warnings.push(group === 'top' ? text(root, 'warningBody', 'Es posible que esta prenda te vaya justa de cuerpo.') : text(root, 'warningHips', 'Es posible que esta prenda te vaya justa de cadera.'));

    if (group !== 'bottom' && result.best.pechoDiff > 5) warnings.push(text(root, 'warningBust', 'Es posible que esta prenda te vaya justa de pecho.'));



    return warnings;

  }





  function renderComparison(root, best, data, group) {

    const rows = [];

    const yourSize = text(root, 'yourSize', 'Tu talla');

    const recommendedSizeLabel = text(root, 'recommendedSizeLabel', 'Talla recomendada');

    const yourBra = text(root, 'yourBra', 'Tu talla de sujetador');

    const recommendedBra = text(root, 'recommendedBra', 'Talla sujetador recomendada');



    if (group === 'set') {
      const en = root.dataset.lang === 'en';
      if (data.talla && best.recommendedSize && String(data.talla) !== String(best.recommendedSize)) rows.push(`<li><span>${en ? 'Top: your size / recommended' : 'Top: tu talla / recomendada'}</span><strong>${escapeHtml(data.talla)} / ${escapeHtml(best.recommendedSize)}</strong></li>`);
      if (data.tallaPantalon && best.recommendedPants && String(data.tallaPantalon) !== String(best.recommendedPants)) rows.push(`<li><span>${en ? 'Trousers: your size / recommended' : 'Pantalón: tu talla / recomendada'}</span><strong>${escapeHtml(data.tallaPantalon)} / ${escapeHtml(best.recommendedPants)}</strong></li>`);
      if (data.sujetador && best.recommendedBra && String(data.sujetador) !== String(best.recommendedBra)) rows.push(`<li><span>${escapeHtml(yourBra)} / ${escapeHtml(recommendedBra)}</span><strong>${escapeHtml(data.sujetador)} / ${escapeHtml(best.recommendedBra)}</strong></li>`);
      return rows.length ? `<div class="nbl-size-calculator__measures nbl-size-calculator__comparison"><ul>${rows.join('')}</ul></div>` : '';
    }
    if (data.talla && best.recommendedSize && String(data.talla) !== String(best.recommendedSize)) {

      rows.push(`<li><span>${escapeHtml(yourSize)}</span><strong>${escapeHtml(data.talla)}</strong></li>`);

      rows.push(`<li><span>${escapeHtml(recommendedSizeLabel)}</span><strong>${escapeHtml(best.recommendedSize)}</strong></li>`);

    }



    if (group !== 'bottom' && data.sujetador && best.recommendedBra && String(data.sujetador) !== String(best.recommendedBra)) {

      rows.push(`<li><span>${escapeHtml(yourBra)}</span><strong>${escapeHtml(data.sujetador)}</strong></li>`);

      rows.push(`<li><span>${escapeHtml(recommendedBra)}</span><strong>${escapeHtml(best.recommendedBra)}</strong></li>`);

    }



    return rows.length ? `<div class="nbl-size-calculator__measures nbl-size-calculator__comparison"><ul>${rows.join('')}</ul></div>` : '';

  }



  function renderResult(root, resultEl, recommendation, group, data) {

    const best = recommendation.best;

    const warnings = buildWarnings(root, recommendation, group);

    const form = root.querySelector('.nbl-size-calculator__form');

    const progress = root.querySelector('.nbl-size-calculator__progress');

    const recommendText = text(root, 'recommend', 'Te recomendamos');

    const modifyText = text(root, 'modify', 'Modificar datos');

    const oneSizeCompatible = text(root, 'onesizeCompatible', 'Esta prenda es compatible con tus medidas');

    const oneSizeIncompatible = text(root, 'onesizeIncompatible', 'Esta prenda puede no ser compatible con tus medidas');

    const showComparison = warnings.length > 0 || !recommendation.hasCompatible;



    if (form) form.hidden = true;

    if (progress) progress.hidden = true;



    resultEl.hidden = false;

    resultEl.innerHTML = `

      <div class="nbl-size-calculator__recommendation nbl-size-calculator__recommendation--final">

        ${best.isOneSize

          ? `<strong>${escapeHtml(recommendation.hasCompatible ? oneSizeCompatible : oneSizeIncompatible)}</strong>`

          : `<span>${escapeHtml(recommendText)}</span><strong>${escapeHtml(getVariantSize(root, best.variant))}</strong>`}

      </div>

      ${warnings.length ? `<div class="nbl-size-calculator__warnings">${warnings.map(w => `<div class="nbl-size-calculator__warning">${escapeHtml(w)}</div>`).join('')}</div>` : ''}

      ${showComparison ? renderComparison(root, best, data || {}, group) : ''}

      ${renderMeasures(root, best.variant, group)}

      ${renderMeasureImage(root)}

      <button type="button" class="nbl-size-calculator__restart" data-nbl-restart>${escapeHtml(modifyText)}</button>

    `;



    const restart = resultEl.querySelector('[data-nbl-restart]');

    if (restart) restart.addEventListener('click', function(){

      resultEl.hidden = true;

      if (form) form.hidden = false;

      if (progress) progress.hidden = false;

    });

  }



  function renderError(result, message) {

    result.hidden = false;

    result.innerHTML = `<div class="nbl-size-calculator__warning">${escapeHtml(message)}</div>`;

  }



  function renderInlineError(step, message) {

    step.querySelectorAll('.nbl-size-calculator__step-error').forEach(el => el.remove());

    const error = document.createElement('div');

    error.className = 'nbl-size-calculator__step-error';

    error.textContent = message;

    step.appendChild(error);

  }



  function clearInlineError(step) {

    step.querySelectorAll('.nbl-size-calculator__step-error').forEach(el => el.remove());

  }



  function validateStep(step) {

    return Array.from(step.querySelectorAll('input, select')).some(field => field.name && field.value === '');

  }



  function initWizard(root, form, result) {

    const steps = Array.from(form.querySelectorAll('.nbl-size-step'));

    const progressLabel = root.querySelector('[data-nbl-progress-label]');

    const dotsRoot = root.querySelector('[data-nbl-progress-dots]');

    const backBtn = root.querySelector('[data-nbl-back]');

    const nextBtn = root.querySelector('[data-nbl-next]');

    const submitBtn = root.querySelector('[data-nbl-submit]');

    let current = 0;



    function renderDots() {

      if (!dotsRoot) return;

      dotsRoot.innerHTML = '';

      steps.forEach((_, index) => {

        const dot = document.createElement('span');

        dot.className = 'nbl-size-calculator__dot';

        if (index < current) dot.classList.add('is-complete');

        if (index === current) dot.classList.add('is-active');

        dotsRoot.appendChild(dot);

      });

    }



    function update() {

      steps.forEach((step, index) => { step.hidden = index !== current; });

      if (progressLabel) progressLabel.textContent = `${Math.min(current + 1, steps.length)}/${steps.length} ${text(root, 'questions', 'preguntas')}`;

      renderDots();



      const actions = root.querySelector('.nbl-size-calculator__actions');

      if (actions) {

        actions.classList.toggle('is-first-step', current === 0);

        actions.classList.toggle('is-final-step', current >= steps.length - 1 || steps.length === 1);

      }



      if (backBtn) backBtn.hidden = current === 0;

      if (nextBtn) nextBtn.hidden = current >= steps.length - 1 || steps.length === 1;

      if (submitBtn) submitBtn.hidden = current < steps.length - 1 && steps.length > 1;

      if (result) result.hidden = true;

    }



    function next() {

      const step = steps[current];

      if (validateStep(step)) {

        renderInlineError(step, text(root, 'stepError', 'Selecciona una opción para continuar.'));

        return;

      }

      clearInlineError(step);

      if (current < steps.length - 1) {

        current += 1;

        update();

      }

    }



    function back() {

      if (current > 0) {

        current -= 1;

        update();

      }

    }



    nextBtn && nextBtn.addEventListener('click', next);

    backBtn && backBtn.addEventListener('click', back);

    form.addEventListener('keydown', function(event){

      if (event.key === 'Enter' && current < steps.length - 1) {

        event.preventDefault();

        next();

      }

    });



    update();

  }



  function initCalculator(root) {

    if (!root || root.dataset.initialized === '1') return;

    root.dataset.initialized = '1';



    const group = root.dataset.group || 'full';

    const trigger = root.querySelector('.nbl-size-calculator__trigger');

    const panel = root.querySelector('.nbl-size-calculator__panel');

    const close = root.querySelector('.nbl-size-calculator__close');

    const form = root.querySelector('.nbl-size-calculator__form');

    const result = root.querySelector('.nbl-size-calculator__result');

    let variants = [];



    try {

      variants = JSON.parse(root.dataset.variants || '[]').filter(v => v.ok && v.available);

    } catch(e) {

      variants = [];

    }



    fillFormFromProfile(form, loadProfile(), group);



    function openPanel() {

      panel.hidden = false;

      document.documentElement.classList.add('nbl-size-calculator-open');

    }



    function closePanel() {

      panel.hidden = true;

      document.documentElement.classList.remove('nbl-size-calculator-open');

    }



    trigger && trigger.addEventListener('click', openPanel);

    close && close.addEventListener('click', closePanel);

    panel && panel.addEventListener('click', event => { if (event.target === panel) closePanel(); });

    document.addEventListener('keydown', event => { if (event.key === 'Escape' && panel && !panel.hidden) closePanel(); });



    if (!form) return;



    initWizard(root, form, result);



    form.addEventListener('submit', function(event) {

      event.preventDefault();

      const data = collectData(form);



      if (!data.talla || (group !== 'bottom' && !data.sujetador)) {

        renderError(result, text(root, 'completeError', 'Completa los datos para calcular tu talla.'));

        return;

      }



      if (!variants.length) {

        renderError(result, text(root, 'unavailableError', 'Ahora mismo no podemos calcular la talla de este producto.'));

        return;

      }



      const profile = loadProfile();

      profile[group] = data;

      saveProfile(profile);



      const recommendation = calculateRecommendation(variants, data, group);

      if (!recommendation || !recommendation.best) {

        renderError(result, text(root, 'unavailableError', 'Ahora mismo no podemos calcular la talla de este producto.'));

        return;

      }



      renderResult(root, result, recommendation, group, data);

    });

  }



  function boot() {

    document.querySelectorAll('[data-nbl-size-calculator]').forEach(initCalculator);

  }



  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);

  else boot();

  // Reinitialize when the theme swaps product HTML after a variant change.
  if (!window.nblCalculatorObserverInstalled) {
    window.nblCalculatorObserverInstalled = true;
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 &&
              (node.matches('[data-nbl-size-calculator]') || node.querySelector('[data-nbl-size-calculator]'))) {
            boot();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }

})();
